import {createAction} from "@reduxjs/toolkit";

export const pushArticles = createAction('PUSH_ARTICLES');